import { createConfigContext } from '@pegasus/config';
import { injectAccessors } from 'config/accessors';
import { ClientConfig } from 'config';

const {
    ConfigProvider,
    useConfig,
    injectConfig,
    withConfig,
    loadConfigFromBootstrap,
} = createConfigContext<ClientConfig>({
    isEnabled: (_: string) => false,
    getUrl: (_: string) => '/',
} as ClientConfig);

export const loadConfig = () => {
    return injectAccessors(loadConfigFromBootstrap());
};

export { ConfigProvider, useConfig, injectConfig, withConfig, loadConfigFromBootstrap };
